import { withTheme as muiWithTheme } from '@material-ui/core/styles';
import { WithTheme as MuiWithTheme, ThemedComponentProps as MuiThemedComponentProps } from '@material-ui/core/styles/withTheme';
import { PropInjector } from '@material-ui/core';
import createMuiTheme, { Theme as MuiTheme, ThemeOptions as MuiThemeOptions } from '@material-ui/core/styles/createMuiTheme';
import {
    Palette as MuiPalette,
    PaletteColor as MuiPaletteColor,
    PaletteOptions as MuiPaletteOptions,
    PaletteColorOptions as MuiPaletteColorOptions
} from '@material-ui/core/styles/createPalette';

import green from '@material-ui/core/colors/green';
import lightBlue from '@material-ui/core/colors/lightBlue';
import amber from '@material-ui/core/colors/amber';
import deepOrange from '@material-ui/core/colors/deepOrange';


export { WithStyles, withStyles, createStyles, StyleRules, StyleRulesCallback } from '@material-ui/core/styles';
export type PaletteColorOptions = MuiPaletteColorOptions;
export type PaletteColor = MuiPaletteColor;



export interface WithTheme extends MuiWithTheme {
    theme: Theme;
}



export const withTheme = (): PropInjector<WithTheme, MuiThemedComponentProps> => {
    return muiWithTheme();
}

export interface PaletteOptions extends MuiPaletteOptions {
    success?: PaletteColorOptions;
    info?: PaletteColorOptions;
    warning?: PaletteColorOptions;
    danger?: PaletteColorOptions;
}

export interface ThemeOptions extends MuiThemeOptions {
    palette: PaletteOptions;
}


export interface Palette extends MuiPalette {
    success: PaletteColor;
    info: PaletteColor;
    warning: PaletteColor;
    danger: PaletteColor;
}

export interface Theme extends MuiTheme {
    palette: Palette;

}

export const createTheme = (options: ThemeOptions): Theme => {

    const {
        success = {
            light: green[300],
            main: green[500],
            dark: green[700],
        },
        info = {
            light: lightBlue[300],
            main: lightBlue[500],
            dark: lightBlue[700],
        },
        warning = {
            light: amber.A200,
            main: amber.A400,
            dark: amber.A700,
        },
        danger = {
            light: deepOrange[300],
            main: deepOrange[500],
            dark: deepOrange[700],
        },
    } = options.palette;

    const muiTheme = createMuiTheme({
        palette: {
            ...options.palette,
            success: success,
            info: info,
            warning: warning,
            danger: danger
        },
        ...options,
    });

    muiTheme.palette.augmentColor(success);
    muiTheme.palette.augmentColor(info);
    muiTheme.palette.augmentColor(warning);
    muiTheme.palette.augmentColor(danger);

    const theme: Theme = {
        ...muiTheme,
        palette: {
            ...muiTheme.palette,
            success: success as PaletteColor,
            info: info as PaletteColor,
            warning: warning as PaletteColor,
            danger: danger as PaletteColor,
        }
    }

    return theme;
}